module.exports = __webpack_public_path__ + "static/fonts/icons.718106a.woff";


//////////////////
// WEBPACK FOOTER
// ./autocomplete-component/src/fonts/icons.woff
// module id = vSmF
// module chunks = 1